<template>
  <footer-item v-if="isChinese"
               :clickHandler="setEnglishLanguage"
               text="English">
    <svg-icon name="language" class="language-icon grey-icon"></svg-icon>
  </footer-item>
  <footer-item v-else-if="!isChinese"
               :clickHandler="setChineseLanguage"
               text="中文">
    <svg-icon name="language" class="grey-icon"></svg-icon>
  </footer-item>
</template>

<script>

import '../../distribution/icons/language';

import FooterItem from './FooterItem';

export default {
  props: {
    setChineseLanguage: Function,
    setEnglishLanguage: Function,
    isChinese: Boolean
  },
  components: {FooterItem}
};
</script>
